/* AlgoBox theme JS: header, collection sort/filter, product variant picker, cart ajax. */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = (window.ABTheme && window.ABTheme.moneyFormat) || '${{amount}}';
    var val = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, val).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };

  /* ---------- header ---------- */
  var burger = document.querySelector('[data-burger]');
  var mnav = document.querySelector('[data-mobile-nav]');
  if (burger && mnav) burger.addEventListener('click', function () { mnav.classList.toggle('open'); });

  /* ---------- home: rising-particle background (see CLAUDE.md "Homepage background") ---------- */
  var pcanvas = document.getElementById('abx-particles');
  if (pcanvas && pcanvas.getContext) {
    var pctx = pcanvas.getContext('2d');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var pw = 0, ph = 0, dots = [];
    var COLORS = ['24,180,255', '24,180,255', '24,180,255', '24,180,255', '24,180,255', '0,230,118', '255,47,58'];

    var spawn = function (anywhere) {
      return {
        x: Math.random() * pw,
        y: anywhere ? Math.random() * ph : ph + 4,
        r: 0.8 + Math.random() * 1.6,
        vy: 0.1 + Math.random() * 0.25,
        drift: (Math.random() - 0.5) * 0.08,
        a: 0.06 + Math.random() * 0.22,
        c: COLORS[Math.floor(Math.random() * COLORS.length)]
      };
    };

    var psize = function () {
      pw = window.innerWidth; ph = window.innerHeight;
      pcanvas.width = pw * dpr; pcanvas.height = ph * dpr;
      pctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var target = Math.min(60, Math.round(pw * ph / 30000));
      dots = [];
      for (var i = 0; i < target; i++) dots.push(spawn(true));
    };

    var pdraw = function () {
      pctx.clearRect(0, 0, pw, ph);
      for (var i = 0; i < dots.length; i++) {
        var d = dots[i];
        pctx.beginPath();
        pctx.arc(d.x, d.y, d.r, 0, 6.2832);
        pctx.fillStyle = 'rgba(' + d.c + ',' + d.a + ')';
        pctx.fill();
      }
    };

    var pstep = function () {
      for (var i = 0; i < dots.length; i++) {
        var d = dots[i];
        d.y -= d.vy; d.x += d.drift;
        if (d.y < -6 || d.x < -6 || d.x > pw + 6) dots[i] = spawn(false);
      }
      pdraw();
      requestAnimationFrame(pstep);
    };

    psize();
    window.addEventListener('resize', psize);
    if (reduced) { pdraw(); } else { requestAnimationFrame(pstep); }
  }

  /* ---------- home: fade product cards in on scroll ---------- */
  if (document.body.classList.contains('template-index') &&
      'IntersectionObserver' in window &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var cards = document.querySelectorAll('.pcard');
    var stagger = 0;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.style.transitionDelay = (stagger % 4) * 120 + 'ms';
        stagger++;
        el.classList.add('fade-show');
        io.unobserve(el);
      });
    }, { threshold: 0.15 });
    cards.forEach(function (c) { c.classList.add('fade-wait'); io.observe(c); });
    /* safety net: never leave products invisible if IO doesn't fire */
    setTimeout(function () {
      cards.forEach(function (c) { c.classList.add('fade-show'); });
    }, 3000);
  }

  /* ---------- collection: sort + filters ---------- */
  var sortSel = document.querySelector('[data-sort]');
  if (sortSel) sortSel.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSel.value);
    window.location.href = url.toString();
  });
  var filterForm = document.querySelector('[data-filter-form]');
  if (filterForm) filterForm.addEventListener('change', function () {
    var params = new URLSearchParams(new FormData(filterForm));
    window.location.href = window.location.pathname + '?' + params.toString();
  });

  /* ---------- product ---------- */
  var root = document.querySelector('[data-product-root]');
  if (root) {
    var variantsEl = document.querySelector('[data-variants-json]');
    var optionsEl = document.querySelector('[data-options-json]');
    if (variantsEl && optionsEl) {
      var variants = JSON.parse(variantsEl.textContent);
      var optionNames = JSON.parse(optionsEl.textContent);
      var selected = [];
      root.querySelectorAll('[data-option-index]').forEach(function (optWrap) {
        var idx = parseInt(optWrap.dataset.optionIndex, 10);
        var active = optWrap.querySelector('[data-opt].active');
        selected[idx] = active ? active.dataset.value : null;
      });
      if (!selected.length && variants.length) selected = (variants[0].options || []).slice();

      var applyVariant = function () {
        var v = variants.find(function (vv) {
          return selected.every(function (val, i) { return val == null || vv['option' + (i + 1)] === val; });
        });
        var addBtn = root.querySelector('[data-add]');
        var addLabel = root.querySelector('[data-add-label]');
        var priceEl = root.querySelector('[data-price]');
        var idInput = root.querySelector('[data-variant-id]');
        if (!v) {
          if (addBtn) { addBtn.disabled = true; }
          if (addLabel) addLabel.textContent = 'Unavailable';
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (addBtn) addBtn.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available ? 'Add To Cart · ' + money(v.price) : 'Sold Out';
        if (v.featured_image && v.featured_image.src) {
          var main = root.querySelector('[data-main-image]');
          if (main) main.src = v.featured_image.src;
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      };

      root.querySelectorAll('[data-option-index]').forEach(function (optWrap) {
        var idx = parseInt(optWrap.dataset.optionIndex, 10);
        optWrap.querySelectorAll('[data-opt]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            optWrap.querySelectorAll('[data-opt]').forEach(function (b) { b.classList.remove('active'); });
            btn.classList.add('active');
            selected[idx] = btn.dataset.value;
            var valEl = optWrap.querySelector('[data-option-value]');
            if (valEl) valEl.textContent = btn.dataset.value;
            applyVariant();
          });
        });
      });
    }

    /* gallery thumbs */
    var mainImg = root.querySelector('[data-main-image]');
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        if (mainImg) mainImg.src = t.dataset.full;
      });
    });

    /* lightbox */
    if (mainImg) {
      mainImg.style.cursor = 'zoom-in';
      mainImg.addEventListener('click', function () {
        var box = document.createElement('div');
        box.className = 'lightbox';
        box.innerHTML = '<img src="' + mainImg.src.replace(/width=\d+/, 'width=2048') +
                        '" alt=""><button class="lightbox__close" aria-label="Close">×</button>';
        var close = function () { box.remove(); document.removeEventListener('keydown', onKey); };
        var onKey = function (e) { if (e.key === 'Escape') close(); };
        box.addEventListener('click', close);
        document.addEventListener('keydown', onKey);
        document.body.appendChild(box);
      });
    }

    /* qty stepper */
    var qty = root.querySelector('[data-qty]');
    var dec = root.querySelector('[data-qty-dec]');
    var inc = root.querySelector('[data-qty-inc]');
    if (qty && dec && inc) {
      dec.addEventListener('click', function () { qty.value = Math.max(1, parseInt(qty.value || '1', 10) - 1); });
      inc.addEventListener('click', function () { qty.value = parseInt(qty.value || '1', 10) + 1; });
    }

    /* ajax add-to-cart */
    var form = document.getElementById('product-form');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var addBtn = root.querySelector('[data-add]');
      var addLabel = root.querySelector('[data-add-label]');
      if (addBtn) addBtn.disabled = true;
      if (addLabel) addLabel.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          if (addLabel) addLabel.textContent = 'Could not add — try again';
          if (addBtn) addBtn.disabled = false;
        });
    });
  }

  /* ---------- cart page ---------- */
  var cartRoot = document.querySelector('[data-cart-root]');
  if (cartRoot) {
    var changeLine = function (line, quantity) {
      cartRoot.style.opacity = '0.6';
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function () { window.location.reload(); });
    };
    cartRoot.querySelectorAll('[data-line]').forEach(function (row) {
      var line = parseInt(row.dataset.line, 10);
      var q = row.querySelector('[data-line-qty]');
      row.querySelector('[data-line-dec]').addEventListener('click', function () {
        changeLine(line, Math.max(0, parseInt(q.value, 10) - 1));
      });
      row.querySelector('[data-line-inc]').addEventListener('click', function () {
        changeLine(line, parseInt(q.value, 10) + 1);
      });
      row.querySelector('[data-line-remove]').addEventListener('click', function () { changeLine(line, 0); });
      q.addEventListener('change', function () { changeLine(line, Math.max(0, parseInt(q.value || '0', 10))); });
    });
  }
})();
